import { urlParams } from '../../utils'

const MAIN_URL = process.env.PREACT_APP_MAIN_URL // get main URL from .env

export const getPropertiesUrl = key => {
    return `${MAIN_URL}/api/reservation/pub/${key}/properties`
}

// Available categories
export const availableCategoriesUrl = (key, params) => {
    return urlParams(`${MAIN_URL}/api/reservation/pub/${key}/availableCategories`, params)
}

// Categories info
export const categoriesUrl = (key, propertyId) => {
    return `${MAIN_URL}/api/reservation/pub/${key}/categoryDescriptions?propertyId=${propertyId}`
}

// Prices
export const pricesUrl = (key, params) => {
    return urlParams(`${MAIN_URL}/api/reservation/pub/${key}/prices`, params)
}

// Create order
export const createOrderUrl = (key, propertyId) => {
    return `${MAIN_URL}/api/reservation/pub/${key}/createOrder?propertyId=${propertyId}`
}

export const placeholderImage =
    'https://easyms-gallery.ams3.digitaloceanspaces.com/4b20e2f8-c6dc-4dc5-9821-b6a5e63642e3'



// WEBPACK FOOTER //
// ./modules/api/urls.js